define(["../core/l10n", "../core/utils", "hyperhtml", "../core/ui", "../core/biblio"], function (_l10n, _utils, _hyperhtml, _ui, _biblio) {
  "use strict";

  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n    <div>", "</div>\n    <p class=\"state\" hidden=\"", "\">\n      ", "\n    </p>\n    <section hidden=\"", "\">", "</section>\n  "]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<div>", "</div>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n  <header>\n    <p>\n      An Open-Source, Community-Maintained Database of\n      Web Standards & Related References.\n    </p>\n  </header>\n  <div class=\"searchcomponent\">\n    <input\n      name=\"searchBox\"\n      type=\"search\"\n      autocomplete=\"off\"\n      placeholder=\"Keywords, titles, authors, urls\u2026\">\n    <button\n      type=\"submit\">\n        Search\n    </button>\n    <label>\n      <input type=\"checkbox\" name=\"includeVersions\"> Include all versions.\n    </label>\n  </div>\n"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n    <dt>\n      [", "]\n    </dt>\n    <dd>", "</dd>\n  "]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n    <p class=\"result-stats\">\n      ", " results (", " seconds).\n      ", "\n    </p>\n    <dl class=\"specref-results\">", "</dl>\n  "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n      <p class=\"state\">\n        Your search - <strong> ", " </strong> -\n        did not match any references.\n      </p>\n    "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const button = _ui.ui.addCommand(_l10n.l10n[_l10n.lang].search_specref, show, "Ctrl+Shift+Alt+space", "🔎");

  const specrefURL = "https://specref.herokuapp.com/";
  const refSearchURL = "".concat(specrefURL, "search-refs");
  const reveseLookupURL = "".concat(specrefURL, "reverse-lookup");
  const form = document.createElement("form");

  const renderer = _hyperhtml.default.bind(form);

  const resultList = _hyperhtml.default.bind(document.createElement("div"));

  form.id = "specref-ui";
  /**
   * @param {Map<string, string>} resultMap
   * @param {string} query
   * @param {number} timeTaken
   */

  function renderResults(resultMap, query, timeTaken) {
    if (!resultMap.size) {
      return resultList(_templateObject(), query);
    }

    const wires = Array.from(resultMap).slice(0, 99).map(toDefinitionPair).reduce((collector, pair) => collector.concat(pair), []);
    return resultList(_templateObject2(), resultMap.size, timeTaken, resultMap.size > 99 ? "First 100 results." : "", wires);
  }

  function toDefinitionPair([key, entry]) {
    return _hyperhtml.default.wire(entry)(_templateObject3(), key, (0, _biblio.wireReference)(entry));
  }

  function resultProcessor({
    includeVersions = false
  } = {}) {
    return (...fetchedData) => {
      /** @type {{ [key: string]: any }} */
      const combinedResults = Object.assign({}, ...fetchedData);
      const results = new Map(Object.entries(combinedResults)); // remove aliases

      Array.from(results).filter(([, entry]) => entry.aliasOf).map(([key]) => key).reduce((results, key) => results.delete(key) && results, results); // Remove versions, if asked to

      if (!includeVersions) {
        Array.from(results.values()).filter(entry => typeof entry === "object" && "versions" in entry).reduce(_utils.flatten, []).forEach(version => {
          results.delete(version);
        });
      } // Remove legacy string entries


      Array.from(results).filter(([, value]) => typeof value !== "object").forEach(([key]) => results.delete(key));
      return results;
    };
  }

  form.addEventListener("submit", async ev => {
    ev.preventDefault();
    const {
      searchBox
    } = form;
    const query = searchBox.value;

    if (!query) {
      searchBox.focus();
      return;
    }

    render({
      state: "Searching Specref…"
    });
    const refSearch = new URL(refSearchURL);
    refSearch.searchParams.set("q", query);
    const reverseLookup = new URL(reveseLookupURL);
    reverseLookup.searchParams.set("urls", query);

    try {
      const startTime = performance.now();
      const jsonData = await Promise.all([fetch(refSearch).then(response => response.json()), fetch(reverseLookup).then(response => response.json())]);
      const {
        checked: includeVersions
      } = form.includeVersions;
      const processResults = resultProcessor({
        includeVersions
      });
      const results = processResults(...jsonData);
      render({
        query,
        results,
        state: "",
        timeTaken: Math.round(performance.now() - startTime) / 1000
      });
    } catch (err) {
      console.error(err);
      render({
        state: "Error! Couldn't do search."
      });
    } finally {
      searchBox.focus();
    }
  });

  function show() {
    render();

    _ui.ui.freshModal(_l10n.l10n[_l10n.lang].search_specref, form, button);
    /** @type {HTMLElement} */


    const input = form.querySelector("input[type=search]");
    input.focus();
  }

  const mast = _hyperhtml.default.wire()(_templateObject4());
  /**
   * @param {object} options
   * @param {string} [options.state]
   * @param {Map<string, string>} [options.results]
   * @param {number} [options.timeTaken]
   * @param {string} [options.query]
   */


  function render({
    state = "",
    results,
    timeTaken,
    query
  } = {}) {
    if (!results) {
      renderer(_templateObject5(), mast);
      return;
    }

    renderer(_templateObject6(), mast, !state, state, !results, results ? renderResults(results, query, timeTaken) : []);
  }
});
//# sourceMappingURL=search-specref.js.map